export default __webpack_public_path__ + "static/Nunito-Regular-a960937048f86b6e789ce513815e565f.ttf";